import { filterObjectStore, queryFilter } from 'Redux/Query';

export const getPoolRequests = (state, filter = null) => {
    if(filter === null) {
        filter = queryFilter({sorting: { by: 'createdAt', order: 'DESC' }})
    }

    return filterObjectStore(state.poolRequest.poolRequests.entries, filter);
};
